<template>
  <b-sidebar
    v-if="quoteDistributionItem.id"
    id="sidebar-update-quote-distribution-item"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Quote distribution for {organization}', { organization: $langName(quoteDistributionItem.name) }) }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="quoteDistributionItemUpdate">
          <div class="row">
            <div
              v-for="dcType in dcTypes"
              :key="dcType.id"
              class="col-md-6"
            >
              <validation-provider
                #default="{ errors }"
                :name="$langName(dcType.name)"
                :rules="`required|integer|min_value:0`"
              >
                <!-- Dc amount -->
                <b-form-group
                  :label="$langName(dcType.name) + ` (max: ${quoteDistributionItem[dcType.id] || 0})`"
                  :label-for="'item_' + dcType.id"
                >
                  <b-form-input
                    :id="'item_' + dcType.id"
                    v-model="quoteDistributionItem[`item_${dcType.id}`]"
                    trim
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Update') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  required, integer, maxValue, minValue,
} from '@/libs/validations/validations'
import store from '@/store'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      maxValue,
      minValue,
    }
  },
  computed: {
    quoteDistribution: {
      get() {
        return this.$store.state.quoteDistribution.quoteDistribution
      },
      set(data) {
        this.$store.commit('quoteDistribution/UPDATE', data)
      },
    },
    quoteDistributionItem: {
      get() {
        return this.$store.state.quoteDistribution.quoteDistributionItem
      },
      set(data) {
        this.$store.commit('quoteDistribution/SET_QUOTE_DISTRIBUTION_ITEM', data)
      },
    },
    dcTypes() {
      return this.$store.getters['staticModule/getSimpleDcTypes']
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.freshData()
      hide()
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    freshData() {
      this.$refs.quoteDistributionItemUpdate.reset()
    },
    submit(hide) {
      this.$refs.quoteDistributionItemUpdate.validate().then(success => {
        if (success) {
          const data = {
            total_quote: this.quoteDistribution.id,
            dc_type: {},
            to_org: this.quoteDistributionItem.id,
          }
          this.dcTypes.forEach(dcType => {
            data.dc_type[dcType.id] = this.quoteDistributionItem[`item_${dcType.id}`]
          })
          this.$createSwal(this, data, 'quoteDistribution/updateItem', () => {
            this.freshData()
            this.$emit('refetchData')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const { PhD, DSc, traineeResearcher } = store.state.staticModule
    return {
      PhD,
      DSc,
      traineeResearcher,
    }
  },
}
</script>
<style>
  #sidebar-update-quote-distribution-item {
    width: 50rem;
  }
</style>
